import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getIssueListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `issue?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getVehicleDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `get_vehicle_details/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getIssueEditDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `issue/edit/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getAttachmentListApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `issue/attachment/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getRemoveAttachmentApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `issue/remove_attachment/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const submitIssueAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `issue`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const updateIssueAPI = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `issue/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getIssueViewDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `issue/view/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const saveAttachmentApi = async (id, body) => {
  try {
    const response = await axios.put(
      apiUrl + `issue/add_attachment/` + id,
      body,
      {
        headers: header,
      }
    );
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
